/*
  File: assets/carakit-radiation.js
  CaraKit Radiation — Motion Theme
  Fixed version based on the working Chemotherapy implementation.
*/
(function () {
  'use strict';

  const VARIANTS = Object.freeze({
    small: '41192617869508',
    medium: '40833456832708',
    large: '40833479868612'
  });
  const SIZES = ['small', 'medium', 'large'];

  const esc = (v) => String(v == null ? '' : v)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#039;');

  function money(v) {
    const n = Number(v || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      try { return window.Shopify.formatMoney(Math.round(n * 100), window.Shopify.money_format || '${{amount}}'); } catch (e) {}
    }
    return '$' + n.toFixed(2);
  }

  function rootUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  window.CaraKitOrderGift = window.CaraKitOrderGift || (function () {
    var applying = false;
    var timer = null;
    var state = {
      isGift: false,
      isCompany: false,
      to: '',
      from: '',
      company: '',
      dept: '',
      message: '',
      sendDelivery: false,
      email: ''
    };

    function emptyAttrs() {
      return {
        'Is Gift': '',
        'Gift Type': '',
        'Company Name': '',
        'Department': '',
        'From': '',
        'To': '',
        'Gift Message': '',
        'Send Delivery Email': '',
        'Recipient Email': ''
      };
    }

    function toAttributes() {
      var attrs = emptyAttrs();
      if (!state.isGift) return attrs;
      attrs['Is Gift'] = 'Yes';
      attrs['Gift Type'] = state.isCompany ? 'Company Gift' : 'Personal Gift';
      attrs['To'] = state.to;
      attrs['Gift Message'] = state.message;
      if (state.isCompany) {
        attrs['Company Name'] = state.company;
        attrs['Department'] = state.dept;
      } else {
        attrs['From'] = state.from;
      }
      if (state.sendDelivery) {
        attrs['Send Delivery Email'] = 'Yes';
        attrs['Recipient Email'] = state.email;
      }
      return attrs;
    }

    function toNote() {
      if (!state.isGift) return '';
      var parts = [];
      if (state.to) parts.push('To: ' + state.to);
      if (state.isCompany) {
        if (state.company) parts.push('From: ' + state.company);
        if (state.dept) parts.push('Dept: ' + state.dept);
      } else if (state.from) {
        parts.push('From: ' + state.from);
      }
      if (state.message) parts.push(state.message);
      if (state.sendDelivery && state.email) parts.push('Delivery note: ' + state.email);
      return parts.join('\n');
    }

    function setVal(el, value) {
      if (!el) return;
      if (el.type === 'checkbox') el.checked = !!value;
      else if (el.value !== String(value || '')) el.value = value || '';
    }

    function applyProduct() {
      document.querySelectorAll('.carakit-chemo__gift').forEach(function (box) {
        var gift = box.querySelector('[id^="CarakitRadiationGift-"]');
        var company = box.querySelector('[data-radiation-gift-company-toggle]');
        var fields = box.querySelector('[id^="CarakitRadiationGiftFields-"]');
        var companyWrap = box.querySelector('[id^="CarakitRadiationCompanyFields-"]');
        var fromWrap = box.querySelector('[id^="CarakitRadiationIndividualFromField-"]');
        var emailWrap = box.querySelector('[id^="CarakitRadiationDeliveryEmailWrap-"]');
        var count = box.querySelector('[id^="CarakitRadiationGiftWordCount-"]');
        setVal(gift, state.isGift);
        setVal(company, state.isCompany);
        setVal(box.querySelector('[data-radiation-gift-recipient]'), state.to);
        setVal(box.querySelector('[data-radiation-gift-from]'), state.from);
        setVal(box.querySelector('[data-radiation-gift-company-name]'), state.company);
        setVal(box.querySelector('[data-radiation-gift-department]'), state.dept);
        setVal(box.querySelector('[data-radiation-gift-message]'), state.message);
        setVal(box.querySelector('[data-radiation-delivery-note-toggle]'), state.sendDelivery);
        setVal(box.querySelector('[data-radiation-gift-email]'), state.email);
        if (fields) fields.style.display = state.isGift ? 'grid' : 'none';
        if (companyWrap) companyWrap.style.display = state.isCompany ? 'grid' : 'none';
        if (fromWrap) fromWrap.style.display = state.isCompany ? 'none' : 'grid';
        if (emailWrap) emailWrap.style.display = state.sendDelivery ? 'block' : 'none';
        if (count) {
          var words = state.message.trim() ? state.message.trim().split(/\s+/).length : 0;
          count.textContent = words + '/150 words';
        }
      });
    }

    function applyDrawer() {
      var toggle = document.getElementById('ckGiftToggle');
      var company = document.getElementById('ckCompanyGift');
      var body = document.querySelector('#CartDrawer .ck-gift-body');
      var count = document.getElementById('ckGiftWords');
      var note = document.getElementById('CartNoteDrawer');
      if (toggle) {
        toggle.classList.toggle('is-on', state.isGift);
        toggle.setAttribute('aria-pressed', state.isGift ? 'true' : 'false');
      }
      setVal(company, state.isCompany);
      if (body) body.classList.toggle('is-company', state.isCompany);
      setVal(document.getElementById('ckGiftTo'), state.to);
      setVal(document.getElementById('ckGiftFrom'), state.from);
      setVal(document.getElementById('ckGiftCompany'), state.company);
      setVal(document.getElementById('ckGiftDept'), state.dept);
      setVal(document.getElementById('ckGiftMessage'), state.message);
      setVal(document.getElementById('ckDeliveryNote'), state.sendDelivery);
      setVal(document.getElementById('ckGiftEmail'), state.email);
      if (count) {
        var words = state.message.trim() ? state.message.trim().split(/\s+/).length : 0;
        count.textContent = words + '/150 words';
      }
      if (note) note.value = toNote();
    }

    function applyAll() {
      applying = true;
      applyProduct();
      applyDrawer();
      applying = false;
    }

    function readProduct(box) {
      if (!box) return;
      var gift = box.querySelector('[id^="CarakitRadiationGift-"]');
      var company = box.querySelector('[data-radiation-gift-company-toggle]');
      var to = box.querySelector('[data-radiation-gift-recipient]');
      var from = box.querySelector('[data-radiation-gift-from]');
      var companyName = box.querySelector('[data-radiation-gift-company-name]');
      var dept = box.querySelector('[data-radiation-gift-department]');
      var message = box.querySelector('[data-radiation-gift-message]');
      var send = box.querySelector('[data-radiation-delivery-note-toggle]');
      var email = box.querySelector('[data-radiation-gift-email]');
      state.isGift = !!(gift && gift.checked);
      state.isCompany = !!(company && company.checked);
      state.to = to ? to.value : '';
      state.from = from ? from.value : '';
      state.company = companyName ? companyName.value : '';
      state.dept = dept ? dept.value : '';
      state.message = message ? message.value : '';
      state.sendDelivery = !!(send && send.checked);
      state.email = email ? email.value : '';
    }

    function readDrawer() {
      var toggle = document.getElementById('ckGiftToggle');
      if (!toggle && !document.getElementById('ckGiftTo')) return;
      state.isGift = !!(toggle && toggle.classList.contains('is-on'));
      var company = document.getElementById('ckCompanyGift');
      state.isCompany = !!(company && company.checked);
      state.to = (document.getElementById('ckGiftTo') || {}).value || '';
      state.from = (document.getElementById('ckGiftFrom') || {}).value || '';
      state.company = (document.getElementById('ckGiftCompany') || {}).value || '';
      state.dept = (document.getElementById('ckGiftDept') || {}).value || '';
      state.message = (document.getElementById('ckGiftMessage') || {}).value || '';
      state.sendDelivery = !!(document.getElementById('ckDeliveryNote') || {}).checked;
      state.email = (document.getElementById('ckGiftEmail') || {}).value || '';
    }

    function save() {
      return fetch('/cart/update.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: toAttributes(), note: toNote() })
      }).catch(function () {});
    }

    function queueSave() {
      clearTimeout(timer);
      timer = setTimeout(save, 400);
    }

    function isGiftToggleEl(el) {
      if (!el) return false;
      if (el.id === 'ckGiftToggle') return true;
      if (el.matches && el.matches('[id^="CarakitRadiationGift-"]')) return true;
      return !!(el.id && el.id.indexOf('CarakitRadiationGift-') === 0);
    }

    function changedFrom(source, event) {
      if (applying) return;
      if (source === 'drawer') readDrawer();
      else readProduct(source);
      var target = event && event.target;
      if (!isGiftToggleEl(target) && !state.isGift && (state.to || state.from || state.company || state.message || state.email)) {
        state.isGift = true;
      }
      applyAll();
      queueSave();
    }

    function bindProduct(box) {
      if (!box || box.getAttribute('data-ck-gift-bound')) return;
      box.setAttribute('data-ck-gift-bound', '1');
      box.addEventListener('input', function (event) { changedFrom(box, event); });
      box.addEventListener('change', function (event) { changedFrom(box, event); });
    }

    function bindDrawer() {
      ['ckGiftToggle', 'ckCompanyGift', 'ckGiftTo', 'ckGiftFrom', 'ckGiftCompany', 'ckGiftDept', 'ckGiftMessage', 'ckDeliveryNote', 'ckGiftEmail'].forEach(function (id) {
        var el = document.getElementById(id);
        if (!el || el.getAttribute('data-ck-order-gift')) return;
        el.setAttribute('data-ck-order-gift', '1');
        el.addEventListener(id === 'ckGiftToggle' ? 'click' : 'input', function (event) {
          setTimeout(function () { changedFrom('drawer', event); }, 0);
        });
        el.addEventListener('change', function (event) { changedFrom('drawer', event); });
      });
    }

    function loadFromCart() {
      return fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var a = cart.attributes || {};
          if (a['Is Gift'] !== 'Yes' && !a['To'] && !a['Gift Message'] && !a['From']) return;
          state.isGift = a['Is Gift'] === 'Yes';
          state.isCompany = a['Gift Type'] === 'Company Gift';
          state.to = a['To'] || '';
          state.from = a['From'] || '';
          state.company = a['Company Name'] || '';
          state.dept = a['Department'] || '';
          state.message = a['Gift Message'] || '';
          state.sendDelivery = a['Send Delivery Email'] === 'Yes';
          state.email = a['Recipient Email'] || '';
          applyAll();
        })
        .catch(function () {});
    }

    function init() {
      document.querySelectorAll('.carakit-chemo__gift').forEach(bindProduct);
      bindDrawer();
      loadFromCart();
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();

    return { save: save, apply: applyAll, state: state };
  })();

  function drawerTrigger() {
    return document.querySelector('.js-drawer-open-cart') ||
      document.querySelector('[aria-controls="CartDrawer"]') ||
      document.querySelector('[aria-controls*="Cart"]') ||
      document.querySelector('.site-nav__link--cart') ||
      document.querySelector('a[href="/cart"]');
  }

  function icon(name) {
    const n = String(name || '').toLowerCase();
    const icons = {
      flower2: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M12 5a3 3 0 1 1 3 3m-3-3a3 3 0 1 0-3 3m3-3v1M9 8a3 3 0 1 0 3 3M9 8h1m5 0a3 3 0 1 1-3 3m3-3h-1m-2 3v-1\"/><circle cx=\"12\" cy=\"8\" r=\"2\"/><path d=\"M12 10v12\"/><path d=\"M12 22c4.2 0 7-1.667 7-5-4.2 0-7 1.667-7 5Z\"/><path d=\"M12 22c-4.2 0-7-1.667-7-5 4.2 0 7 1.667 7 5Z\"/></svg>",
      leaf: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z\"/><path d=\"M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12\"/></svg>",
      pipette: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m2 22 1-1h3l9-9\"/><path d=\"M3 21v-3l9-9\"/><path d=\"m15 6 3.4-3.4a2.1 2.1 0 1 1 3 3L18 9l.4.4a2.1 2.1 0 1 1-3 3l-3.8-3.8a2.1 2.1 0 1 1 3-3l.4.4Z\"/></svg>",
      sofa: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20 9V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v3\"/><path d=\"M2 16a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-5a2 2 0 0 0-4 0v1.5a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5V11a2 2 0 0 0-4 0z\"/><path d=\"M4 18v2\"/><path d=\"M20 18v2\"/><path d=\"M12 4v9\"/></svg>",
      shirt: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M20.38 3.46 16 2a4 4 0 0 1-8 0L3.62 3.46a2 2 0 0 0-1.34 2.23l.58 3.47a1 1 0 0 0 .99.84H6v10c0 1.1.9 2 2 2h8a2 2 0 0 0 2-2V10h2.15a1 1 0 0 0 .99-.84l.58-3.47a2 2 0 0 0-1.34-2.23z\"/></svg>",
      candy: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"m9.5 7.5-2 2a4.95 4.95 0 1 0 7 7l2-2a4.95 4.95 0 1 0-7-7Z\"/><path d=\"M14 6.5v10\"/><path d=\"M10 7.5v10\"/><path d=\"m16 7 1-5 1.37.68A3 3 0 0 0 19.7 3H21v1.3c0 .46.1.92.32 1.33L22 7l-5 1\"/><path d=\"m8 17-1 5-1.37-.68A3 3 0 0 0 4.3 21H3v-1.3a3 3 0 0 0-.32-1.33L2 17l5-1\"/></svg>",
      coffee: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 2v2\"/><path d=\"M14 2v2\"/><path d=\"M16 8a1 1 0 0 1 1 1v8a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V9a1 1 0 0 1 1-1h14a4 4 0 1 1 0 8h-1\"/><path d=\"M6 2v2\"/></svg>",
      pillBottle: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M18 11h-4a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h4\"/><path d=\"M6 7v13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V7\"/><rect width=\"16\" height=\"5\" x=\"4\" y=\"2\" rx=\"1\"/></svg>",
      heart: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z\"/></svg>",
      shoppingBag: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4Z\"/><path d=\"M3 6h18\"/><path d=\"M16 10a4 4 0 0 1-8 0\"/></svg>",
      bath: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 4 8 6\"/><path d=\"M17 19v2\"/><path d=\"M2 12h20\"/><path d=\"M7 19v2\"/><path d=\"M9 5 7.621 3.621A2.121 2.121 0 0 0 4 5v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5\"/></svg>",
      glassWater: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M5.116 4.104A1 1 0 0 1 6.11 3h11.78a1 1 0 0 1 .994 1.105L17.19 20.21A2 2 0 0 1 15.2 22H8.8a2 2 0 0 1-2-1.79z\"/><path d=\"M6 12a5 5 0 0 1 6 0 5 5 0 0 0 6 0\"/></svg>",
      sparkles: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z\"/><path d=\"M20 3v4\"/><path d=\"M22 5h-4\"/><path d=\"M4 17v2\"/><path d=\"M5 18H3\"/></svg>",
      droplets: "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M7 16.3c2.2 0 4-1.83 4-4.05 0-1.16-.57-2.26-1.71-3.19S7.29 6.75 7 5.3c-.29 1.45-1.14 2.84-2.29 3.76S3 11.1 3 12.25c0 2.22 1.8 4.05 4 4.05z\"/><path d=\"M12.56 6.6A10.97 10.97 0 0 0 14 3.02c.5 2.5 2 4.9 4 6.5s3 3.5 3 5.5a6.98 6.98 0 0 1-11.91 4.97\"/></svg>"
    };

    if (n.includes('calendula') || n.includes('flower')) return icons.flower2;
    if (n.includes('essential oil roller') || (n.includes('roller') && n.includes('oil')) || n.includes('roll-on')) return icons.pipette;
    if (n.includes('bracelet')) return icons.sparkles;
    if (n.includes('shawl')) return icons.sofa;
    if (n.includes('sock')) return icons.shirt;
    if (n.includes('caramel') || n.includes('candy') || n.includes('chocolate')) return icons.candy;
    if (n.includes('tea') || n.includes('mug') || n.includes('coffee')) return icons.coffee;
    if (n.includes('lip balm') || n.includes('lipbalm') || n.includes('waxelene lip')) return icons.pillBottle;
    if (n.includes('heart') || n.includes('stone')) return icons.heart;
    if (n.includes('tote') || n.includes('bag')) return icons.shoppingBag;
    if (n.includes('waxelene') || n.includes('ointment') || n.includes('bath') || n.includes('soak')) return icons.bath;
    if (n.includes('water bottle') || n.includes('hydration') || n.includes('electrolyte')) return icons.glassWater;
    if (n.includes('aloe') || n.includes('essential oil') || n.includes('leaf') || n.includes('oil')) return icons.leaf;
    if (n.includes('cream') || n.includes('gel') || n.includes('spray') || n.includes('lotion') || n.includes('moisturizer')) return icons.droplets;
    return icons.leaf;
  }

  function boot(sectionId) {
    const root = document.getElementById('CaraKitRadiation-' + sectionId);
    const cfg = window.CaraKitRadiation && window.CaraKitRadiation[sectionId];
    if (!root || !cfg) return;
    const q = (s) => root.querySelector(s);

    const main = q('#CarakitRadiationMainImage-' + sectionId);
    const thumbs = q('#CarakitRadiationThumbs-' + sectionId);
    const cards = q('#CarakitRadiationSizeCards-' + sectionId);
    const price = q('#CarakitRadiationPrice-' + sectionId);
    const short = q('#CarakitRadiationShortDescription-' + sectionId);
    const tagline = q('#CarakitRadiationTagline-' + sectionId);
    const qtyEl = q('#CarakitRadiationQuantity-' + sectionId);
    const add = q('#CarakitRadiationAddToCart-' + sectionId);
    const why = q('#CarakitRadiationWhy-' + sectionId);
    const items = q('#CarakitRadiationWhatsInside-' + sectionId);
    const comparison = q('#CarakitRadiationComparison-' + sectionId);
    const exclusive = q('#CarakitRadiationExclusive-' + sectionId);
    const whyChoose = q('#CarakitRadiationWhyChoose-' + sectionId);
    const instruction = q('#CarakitRadiationInstruction-' + sectionId);
    const instructionWrap = q('#CarakitRadiationInstructionWrap-' + sectionId);
    const gift = q('#CarakitRadiationGift-' + sectionId);
    const giftFields = q('#CarakitRadiationGiftFields-' + sectionId);
    const companyGift = q('#CarakitRadiationCompanyGift-' + sectionId);
    const companyFields = q('#CarakitRadiationCompanyFields-' + sectionId);
    const individualFromField = q('#CarakitRadiationIndividualFromField-' + sectionId);
    const deliveryNoteToggle = q('#CarakitRadiationDeliveryNoteToggle-' + sectionId);
    const deliveryEmailWrap = q('#CarakitRadiationDeliveryEmailWrap-' + sectionId);
    const giftMessage = q('[data-radiation-gift-message]');
    const wordCount = q('#CarakitRadiationGiftWordCount-' + sectionId);
    const buildOn = q('#CarakitRadiationBuildOn-' + sectionId);
    const buildOnBottom = q('#CarakitRadiationBuildOnBottom-' + sectionId);
    const finalBuild = q('#CarakitRadiationFinalBuildOn-' + sectionId);
    const accordion = q('[data-radiation-accordion]');

    const params = new URLSearchParams(window.location.search);
    let selected = SIZES.includes(params.get('size')) ? params.get('size') : 'medium';
    let quantity = 1;
    let galleryIndex = 0;
    let expanded = true;
    let adding = false;

    async function hydrateProducts() {
      const needsProducts = SIZES.some((key) => {
        const d = cfg.sizes[key] || {};
        return !d.variantImage || !Array.isArray(d.gallery) || d.gallery.length === 0 || !Number(d.price);
      });
      if (!needsProducts) return;

      try {
        const response = await fetch(rootUrl() + 'products.json?limit=250', {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        });
        if (!response.ok) return;
        const payload = await response.json();
        const products = Array.isArray(payload.products) ? payload.products : [];

        SIZES.forEach((key) => {
          const wanted = String(cfg.variants[key] || VARIANTS[key]);
          const product = products.find((p) => Array.isArray(p.variants) && p.variants.some((v) => String(v.id) === wanted));
          if (!product) return;

          const variant = product.variants.find((v) => String(v.id) === wanted) || product.variants[0];
          const images = Array.isArray(product.images) ? product.images : [];
          const gallery = images.map((img) => ({
            src: img.src || img.url || '',
            thumb: img.src || img.url || '',
            alt: img.alt || product.title || 'Radiation Care Kit'
          })).filter((m) => m.src);

          const d = cfg.sizes[key] || (cfg.sizes[key] = {});
          d.price = Number(variant.price || 0);
          d.priceText = '$' + d.price.toFixed(2);
          d.variantImage = (product.featured_image && (product.featured_image.src || product.featured_image)) || (gallery[0] && gallery[0].src) || '';
          d.gallery = gallery;
          d.productHandle = product.handle || '';
          d.productTitle = product.title || d.name;
        });
      } catch (error) {
        console.warn('CaraKit Radiation product media could not be loaded:', error);
      }
    }

    function data() { return cfg.sizes[selected]; }
    function setUrl() {
      const u = new URL(window.location.href);
      u.searchParams.set('size', selected);
      window.history.replaceState({}, '', u.toString());
    }

    function renderCards() {
      if (!cards) return;

      cards.innerHTML = SIZES.map((key) => {
        const d = cfg.sizes[key];

        return `<button type="button" class="carakit-chemo__size-card ${selected === key ? 'is-active' : ''}" data-radiation-size="${key}">
          <h3>${esc(key[0].toUpperCase() + key.slice(1))}</h3>
          <div class="price">${esc(d.priceText)}</div>
          <div class="meta">${esc(d.itemsCount)} items</div>
        </button>`;
      }).join('');

      cards.querySelectorAll('[data-radiation-size]').forEach((b) => {
        b.addEventListener('click', () => setSize(b.dataset.radiationSize, true));
      });
    }

    function renderGallery(d) {
      if (!main || !thumbs) return;
      let list = [];
      if (d.variantImage) list.push({src: d.variantImage, thumb: d.variantImage, alt: d.name});
      (Array.isArray(d.gallery) ? d.gallery : []).forEach((m) => {
        if (!m) return;
        const item = typeof m === 'string' ? {src: m, thumb: m, alt: d.name} : m;
        if (item.src) list.push(item);
      });
      const seen = new Set();
      list = list.filter((m) => !seen.has(m.src) && seen.add(m.src));
      if (!list.length) {
        main.removeAttribute('src');
        main.alt = d.name;
        thumbs.innerHTML = '';
        thumbs.hidden = true;
        return;
      }
      galleryIndex = Math.max(0, Math.min(galleryIndex, list.length - 1));
      const current = list[galleryIndex];
      main.src = current.src;
      main.alt = current.alt || d.name;
      main.style.display = 'block';
      thumbs.hidden = list.length < 2;
      thumbs.innerHTML = list.map((m, i) => `<button type="button" class="carakit-chemo__thumb ${i === galleryIndex ? 'is-active' : ''}" data-radiation-gallery-index="${i}" aria-label="View image ${i + 1}"><img src="${esc(m.thumb || m.src)}" alt="${esc(m.alt || d.name)}" loading="lazy"></button>`).join('');
      thumbs.querySelectorAll('[data-radiation-gallery-index]').forEach((b) => b.addEventListener('click', () => { galleryIndex = Number(b.dataset.radiationGalleryIndex) || 0; renderGallery(d); }));
    }

    function renderItems(d) {
      if (!items) return;
      items.style.display = expanded ? 'grid' : 'none';
      items.innerHTML = (d.items || []).map((item) => `
        <article class="carakit-chemo__item-card">
          <div class="carakit-chemo__item-icon-placeholder">
            ${icon(item[0])}
          </div>
          <h4>${esc(item[0])}</h4>
          <p>${esc(item[1])}</p>
        </article>
      `).join('');
      if (accordion) {
        accordion.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        const a = accordion.querySelector('.carakit-chemo__accordion-icon');
        if (a) a.textContent = expanded ? '✕' : '+';
      }
    }

    function renderComparison() {
      if (!comparison) return;

      const cardData = {
        small: {
          title: 'Small Box',
          label: 'Radiation Essentials',
          bullets: [
            'Thoughtful skin-soothing essentials',
            'Gentle comfort for early treatment days',
            'Ideal for support at the start of radiation'
          ]
        },
        medium: {
          title: 'Medium Box',
          label: 'Radiation Support',
          bullets: [
            'Everything in Small',
            'Expanded comfort + daily care support',
            'Designed for ongoing radiation treatment'
          ]
        },
        large: {
          title: 'Large Box',
          subhead: 'Complete Radiation Support',
          label: 'Complete Care',
          bullets: [
            'Everything in Small + Medium',
            'Comprehensive skin, comfort, and emotional care',
            'Designed to support the full radiation experience—physically and emotionally'
          ]
        }
      };

      comparison.innerHTML = SIZES.map((key) => {
        const d = cfg.sizes[key];
        const info = cardData[key];
        const isActive = selected === key;

        return `
          <button type="button" 
                  class="carakit-chemo__comparison-card ${isActive ? 'is-active' : ''}" 
                  data-radiation-comparison-size="${key}">
            
            ${isActive && info.label ? `<span class="comparison-pill">${esc(info.label)}</span>` : ''}
            
            <h3 class="comparison-card-title">${esc(info.title)}</h3>
            
            ${info.subhead ? `<div class="comparison-card-subhead">${esc(info.subhead)}</div>` : ''}
            
            <ul class="comparison-card-bullets">
              ${info.bullets.map((x) => `<li><span class="check">✓</span> ${esc(x)}</li>`).join('')}
            </ul>

            <div class="comparison-card-footer">
              <span class="price">${esc(d.priceText)}</span>
              <span class="items-count">${d.itemsCount} items</span>
            </div>
          </button>
        `;
      }).join('');

      comparison.querySelectorAll('[data-radiation-comparison-size]').forEach((b) => {
        b.addEventListener('click', () => setSize(b.dataset.radiationComparisonSize, false));
      });
    }

    function renderExclusive(d) {
      if (!exclusive) return;

      const exclusiveItems = {
        small: [
          { title: 'Calendula Cream (2.5 oz)', desc: 'Supports sensitive, radiation-affected skin' },
          { title: 'Aloe Vera Gel – Woolzie\'s', desc: 'Provides cooling hydration for dry, sensitive skin' },
          { title: 'Soft Shawl', desc: 'Provides warmth and comfort during and after treatment' },
          { title: 'Spa Socks', desc: 'Adds warmth for cold treatment rooms' }
        ],
        medium: [
          { title: 'Essential Oil Roller', desc: 'Supports calm and grounding during daily treatments' },
          { title: 'Chamomile Tea', desc: 'Encourages rest and gentle hydration' },
          { title: 'Aloe Vera Spray', desc: 'Easy, cooling skin relief between sessions' },
          { title: 'Soft Caramels', desc: 'A small moment of comfort during long days' },
          { title: 'Lip Balm – Poppy & Pout', desc: 'Hydration support for dry or sensitive lips' },
          { title: 'Tote Bag', desc: 'Practical support for daily radiation visits' }
        ],
        large: [
          { title: 'Heart Mug', desc: 'A comforting ritual for tea, warmth, and routine' },
          { title: 'Heart Talk Book', desc: 'Emotional grounding and reflection during treatment' },
          { title: 'Waxelene Ointment', desc: 'Intensive moisture support for radiation-affected skin' },
          { title: 'Waxelene Lip Balm', desc: 'Deep hydration for persistent dryness' },
          { title: 'Heart Stone', desc: 'A tangible reminder of strength and care' },
          { title: 'Essential Oils Set', desc: 'Multiple blends for calm, grounding, and emotional support' },
          { title: 'Water Bottle', desc: 'Encourages hydration throughout daily treatment cycles' },
          { title: 'Lip Balm', desc: 'Hydration support for dry or sensitive lips' },
          { title: 'Tote Bag', desc: 'Practical support for daily radiation visits' }
        ]
      };

      const subtitleText = {
        small: 'The essential foundation of skin-soothing and comfort',
        medium: '(These items are not in the Small Box)',
        large: '(These items are not in the Small or Medium Box)'
      };

      const exclusiveTitle = selected === 'small'
        ? (d.name + " — What's Inside")
        : (d.name + " — What's Included Only in This Size");

      const currentList = exclusiveItems[selected] || [];
      const mid = currentList.length <= 1
        ? currentList.length
        : Math.floor(currentList.length / 2);
      const left = currentList.slice(0, mid);
      const right = currentList.slice(mid);
      const colHtml = (list) => `
        <div class="exclusive-col">
          ${list.map(item => `
            <div class="exclusive-item">
              <strong>${esc(item.title)}</strong>
              <p>${esc(item.desc)}</p>
            </div>
          `).join('')}
        </div>
      `;

      exclusive.innerHTML = `
        <div class="carakit-chemo__exclusive-box">
          <h3>${esc(exclusiveTitle)}</h3>
          <p class="exclusive-subtitle">${esc(subtitleText[selected])}</p>
          <div class="carakit-chemo__exclusive-2col">
            ${colHtml(left)}
            ${colHtml(right)}
          </div>
        </div>
      `;
    }

    function renderWhyChoose(d) {
      if (!whyChoose) return;
      const title = d.whyChooseTitle || ('Why choose the ' + d.name + '?');
      whyChoose.innerHTML = `
        <div class="carakit-chemo__why-choose">
          <h4 class="carakit-chemo__why-choose-title">${esc(title)}</h4>
          <p class="carakit-chemo__why-choose-text">${esc(d.whyChoose)}</p>
          <p class="carakit-chemo__why-choose-text carakit-chemo__why-choose-best-for">
            <strong>Best for:</strong> ${esc(d.bestFor)}
          </p>
        </div>
      `;
    }

    function updateLink(el) {
      if (!el) return;
      try {
        const u = new URL(cfg.buildOnUrl || '/pages/radiation-build-on', window.location.origin);
        u.searchParams.set('size', selected);
        u.searchParams.set('qty', quantity);
        el.href = u.pathname + u.search;
      } catch (e) {}
    }

    function setAddLabel(label) {
      if (!add) return;
      add.innerHTML = '<span>' + esc(label) + '</span><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12h14"/><path d="m12 5 7 7-7 7"/></svg>';
    }

    function renderMain(d) {
      if (tagline) tagline.textContent = d.tagline || '';
      if (price) price.textContent = d.priceText;
      if (short) short.textContent = d.short;
      if (why) why.textContent = d.why;
      if (qtyEl) qtyEl.textContent = String(quantity);
      setAddLabel('Add to Cart — ' + money(d.price * quantity));
      
      updateLink(buildOn); 
      updateLink(buildOnBottom);
      updateLink(finalBuild);
    }

    function renderInstruction(d) {
      if (!instruction) return;
      if (d.instruction) {
        instruction.src = d.instruction;
        instruction.alt = 'Radiation Care Kit instruction card';
        instruction.style.display = 'block';
        if (instructionWrap) instructionWrap.hidden = false;
      } else {
        instruction.removeAttribute('src');
        instruction.style.display = 'none';
        if (instructionWrap) instructionWrap.hidden = true;
      }
    }

    function render() {
      const d = data();
      if (!d) return;
      renderCards(); renderGallery(d); renderMain(d); renderItems(d); renderComparison(); renderExclusive(d); renderWhyChoose(d); renderInstruction(d);
    }

    function setSize(size, scroll) {
      if (!SIZES.includes(size)) return;
      selected = size; galleryIndex = 0; setUrl(); render();
      if (scroll) window.scrollTo({top: Math.max(0, root.offsetTop - 70), behavior: 'smooth'});
    }

    function properties(d) {
      return { 'Kit Size': d.name };
    }

    async function addToCart() {
      if (adding || !add) return;
      const d = data();
      const variantId = cfg.variants[selected] || VARIANTS[selected];
      if (!variantId) { alert('This kit size is not configured with a Shopify variant ID.'); return; }
      adding = true; add.disabled = true; add.textContent = 'Adding...';
      try {
        if (window.CaraKitOrderGift && typeof window.CaraKitOrderGift.save === 'function') {
          await window.CaraKitOrderGift.save();
        }
        const response = await fetch(rootUrl() + 'cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
          body: JSON.stringify({items: [{id: Number(variantId), quantity: Number(quantity), properties: properties(d)}], sections: ['cart-drawer', 'cart-icon-bubble', 'header'], sections_url: window.location.pathname + window.location.search})
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || result.message || 'Cart request failed');
        const detail = {cart: result, items: result.items || []};
        ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build'].forEach((event) => document.dispatchEvent(new CustomEvent(event, {detail, bubbles: true})));
        if (window.theme && window.theme.cart && typeof window.theme.cart.getCart === 'function') { try { window.theme.cart.getCart(); } catch (e) {} }
        setTimeout(() => {
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') { try { drawer.open(); return; } catch (e) {} }
          const trigger = drawerTrigger(); if (trigger) trigger.click();
        }, 200);
      } catch (e) {
        console.error('CaraKit Radiation cart error:', e);
        alert(e.message || 'Could not add this kit to cart.');
      } finally {
        adding = false; add.disabled = false; setAddLabel('Add to Cart — ' + money(data().price * quantity));
      }
    }

    const minus = q('[data-radiation-qty-minus]');
    const plus = q('[data-radiation-qty-plus]');
    if (minus) minus.addEventListener('click', () => { quantity = Math.max(1, quantity - 1); render(); });
    if (plus) plus.addEventListener('click', () => { quantity += 1; render(); });
    if (add) add.addEventListener('click', (e) => { e.preventDefault(); addToCart(); });
    if (accordion) accordion.addEventListener('click', () => { expanded = !expanded; renderItems(data()); });
    
    if (gift && giftFields) {
      const toggle = () => { giftFields.style.display = gift.checked ? 'grid' : 'none'; };
      toggle(); gift.addEventListener('change', toggle);
    }

    if (companyGift && companyFields && individualFromField) {
      const toggleCompany = () => {
        if (companyGift.checked) {
          companyFields.style.display = 'grid';
          individualFromField.style.display = 'none';
        } else {
          companyFields.style.display = 'none';
          individualFromField.style.display = 'grid';
        }
      };
      toggleCompany();
      companyGift.addEventListener('change', toggleCompany);
    }

    if (deliveryNoteToggle && deliveryEmailWrap) {
      const toggleDeliveryEmail = () => {
        deliveryEmailWrap.style.display = deliveryNoteToggle.checked ? 'block' : 'none';
      };
      toggleDeliveryEmail();
      deliveryNoteToggle.addEventListener('change', toggleDeliveryEmail);
    }

    if (giftMessage && wordCount) giftMessage.addEventListener('input', () => { const t = giftMessage.value.trim(); wordCount.textContent = (t ? t.split(/\s+/).length : 0) + '/150 words'; });
    window.addEventListener('popstate', () => { const p = new URLSearchParams(window.location.search); selected = SIZES.includes(p.get('size')) ? p.get('size') : 'medium'; galleryIndex = 0; render(); });
    render();
    hydrateProducts().then(() => { render(); });
  }

  function init() {
    const sections = window.CaraKitRadiation || {};
    Object.keys(sections).forEach(boot);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();